import {
  AnalyticsIcon
} from "@/components/icons";
import { SideBarRouteOption } from "@/types";
import { CgFileDocument } from "react-icons/cg";
import { IoPersonCircleOutline } from "react-icons/io5";
import { RiUserCommunityFill } from "react-icons/ri";

const licencingAdminRoutes: SideBarRouteOption[] = [
  {
    name: "Analytics",
    path: "/licencing-admin",
    icon: AnalyticsIcon,
  },
  {
    name: "Applications",
    path: "/end-user-account/Certificates",
    icon: CgFileDocument,
  },
  {
    name: "Update Profile",
    path: "/end-user-account/user-profile-settings",
    icon: IoPersonCircleOutline,
  },
  {
    name: "My Profile",
    path: "/end-user-account/user-profile-record",
    icon: RiUserCommunityFill,
  },
];

export default licencingAdminRoutes;
